<div class="flyout-component" [style.width.px]="flyoutWidth ? flyoutWidth : 676" [class.transparent-backdrop]="true">
  @if (flyoutOpeningData && (flyoutOpeningData.type === FlyoutDataTypes.Contact || flyoutOpeningData.type === FlyoutDataTypes.Session)) {
    <app-flyout-headline
      class="flyout-headline flyout-row"
      [flyoutOpeningData]="flyoutOpeningData"
      [isMobile]="isMobile"
      [loadingData]="loadingSessionData || loadingPersonData"></app-flyout-headline>
    @if (!loadingPersonData && !loadingSessionData) {
      @if (errorOnPersonData === false && errorOnSessionData === false) {
        @if (hasSubmittedFormSection) {
          <app-flyout-submitted-form class="flyout-submitted-form-information flyout-row" [flyoutOpeningData]="flyoutOpeningData"></app-flyout-submitted-form>
        }
        @if (hasContactGeneralInfo) {
          <app-flyout-general-info
            class="flyout-general-info flyout-row"
            data-test="flyout-general-info"
            [flyoutOpeningData]="flyoutOpeningData"
            (onClickToScroll)="scroll($event)"></app-flyout-general-info>
        }
        @if (hasContactInformationSection) {
          <app-flyout-contact-information
            class="flyout-contact-information flyout-row"
            [flyoutOpeningData]="flyoutOpeningData"></app-flyout-contact-information>
        }
        @if (hasTagsSection) {
          <app-flyout-tags class="flyout-tags flyout-row" [flyoutOpeningData]="flyoutOpeningData"></app-flyout-tags>
        }
        @if (hasScoresSection) {
          <app-flyout-scores id="flyout-scores" class="flyout-action-list flyout-row" [flyoutOpeningData]="flyoutOpeningData"></app-flyout-scores>
        }
        @if (hasOnsiteCampaignsSection) {
          <app-flyout-campaign-information class="flyout-campaign-information flyout-row"></app-flyout-campaign-information>
        }
        @if (hasDistributedCouponsSection) {
          <app-flyout-distributed-coupons class="flyout-distributed-coupons flyout-row"></app-flyout-distributed-coupons>
        }
        @if (hasGoalsSection) {
          <app-flyout-goals class="flyout-goals flyout-row"></app-flyout-goals>
        }
        @if (hasUtmCampaignSection) {
          <app-flyout-utm-campaigns class="flyout-utm-campaigns flyout-row" [flyoutOpeningData]="flyoutOpeningData"></app-flyout-utm-campaigns>
        }
        @if (hasConsentListSection) {
          <app-flyout-consent-list id="flyout-consents" class="flyout-action-list flyout-row" [flyoutOpeningData]="flyoutOpeningData"></app-flyout-consent-list>
        }
        @if (hasSourceSection) {
          <app-flyout-source class="flyout-source flyout-row" [flyoutOpeningData]="flyoutOpeningData"></app-flyout-source>
        }
        @if (hasActionListSection) {
          <app-flyout-action-list class="flyout-action-list flyout-row" [isMobile]="isMobile" [flyoutOpeningData]="flyoutOpeningData"></app-flyout-action-list>
        }
        @if (hasSesionListSection) {
          <app-flyout-sessions
            id="flyout-sessions"
            class="flyout-action-list flyout-row"
            [isMobile]="isMobile"
            [flyoutOpeningData]="flyoutOpeningData"></app-flyout-sessions>
        }
        @if (hasDeviceSection) {
          <app-flyout-device-info
            id="flyout-device-info"
            class="flyout-action-list flyout-row"
            [flyoutOpeningData]="flyoutOpeningData"></app-flyout-device-info>
        }
      } @else {
        <div class="error-box" data-test="flyout-error">
          <img mat-card-image src="/assets/img/bee_fallen.png" alt="bee_fallen" />
          <p>{{ "generic.error" | translate }}</p>
        </div>
      }
    } @else {
      <div class="loading-box" data-test="flyout-loading">
        <mat-spinner></mat-spinner>
      </div>
    }
  }

  @if (flyoutOpeningData && flyoutOpeningData.type === FlyoutDataTypes.Audience) {
    <app-flyout-audience class="" [flyoutOpeningData]="flyoutOpeningData"></app-flyout-audience>
  }

  @if (flyoutOpeningData && flyoutOpeningData.type === FlyoutDataTypes.AudienceHub) {
    <app-flyout-audience-hub [flyoutOpeningData]="flyoutOpeningData"></app-flyout-audience-hub>
  }

  @if (flyoutOpeningData && flyoutOpeningData.type === FlyoutDataTypes.SessionConditionsOnWidget) {
    <app-flyout-session-on-widget class="" [flyoutOpeningData]="flyoutOpeningData"></app-flyout-session-on-widget>
  }

  @if (flyoutOpeningData && flyoutOpeningData.type === FlyoutDataTypes.AutomationHistory) {
    <app-flyout-automation-history class="" [flyoutOpeningData]="flyoutOpeningData"></app-flyout-automation-history>
  }

  @if (flyoutOpeningData && flyoutOpeningData.type === FlyoutDataTypes.EditResponseList) {
    <app-edit-response-list class="" [flyoutOpeningData]="flyoutOpeningData"></app-edit-response-list>
  }

  @if (flyoutOpeningData && flyoutOpeningData.type === FlyoutDataTypes.UpgradeAccount) {
    <app-flyout-upgrade-account class="" [flyoutOpeningData]="flyoutOpeningData"></app-flyout-upgrade-account>
  }

  @if (flyoutOpeningData && flyoutOpeningData.type === FlyoutDataTypes.FormSettings) {
    <app-flyout-form-settings-v2 [flyoutOpeningData]="flyoutOpeningData"></app-flyout-form-settings-v2>
  }

  @if (flyoutOpeningData && flyoutOpeningData.type === FlyoutDataTypes.Automation) {
    <app-flyout-automations [flyoutOpeningData]="flyoutOpeningData"></app-flyout-automations>
  }

  @if (flyoutOpeningData && flyoutOpeningData.type === FlyoutDataTypes.Referral) {
    <app-flyout-referral-campaigns class="" [flyoutOpeningData]="flyoutOpeningData"></app-flyout-referral-campaigns>
  }

  @if (flyoutOpeningData && flyoutOpeningData.type === FlyoutDataTypes.CampaignFilter) {
    <app-flyout-campaign-filter class="" [flyoutOpeningData]="flyoutOpeningData"></app-flyout-campaign-filter>
  }

  @if (flyoutOpeningData && flyoutOpeningData.type === FlyoutDataTypes.BrandSettings) {
    <app-flyout-brand-settings class="" [flyoutOpeningData]="flyoutOpeningData"></app-flyout-brand-settings>
  }

  @if (flyoutOpeningData && flyoutOpeningData.type === FlyoutDataTypes.WidgetPreview) {
    <app-flyout-widget-preview [flyoutOpeningData]="flyoutOpeningData"></app-flyout-widget-preview>
  }

  @if (flyoutOpeningData && flyoutOpeningData.type === FlyoutDataTypes.CopyAccountSettings) {
    <app-flyout-copy-brand-settings class="" [flyoutOpeningData]="flyoutOpeningData"></app-flyout-copy-brand-settings>
  }

  @if (flyoutOpeningData && flyoutOpeningData.type === FlyoutDataTypes.DataPlatformVisit) {
    <app-data-platform-visit-flyout [flyoutOpeningData]="flyoutOpeningData"></app-data-platform-visit-flyout>
  }

  @if (flyoutOpeningData && flyoutOpeningData.type === FlyoutDataTypes.DataPlatformProfile) {
    <app-data-platform-profile-flyout [flyoutOpeningData]="flyoutOpeningData"></app-data-platform-profile-flyout>
  }

  @if (flyoutOpeningData && flyoutOpeningData.type === FlyoutDataTypes.DataPlatformContact) {
    <app-data-platform-contact-flyout [flyoutOpeningData]="flyoutOpeningData"></app-data-platform-contact-flyout>
  }

  @if (flyoutOpeningData && flyoutOpeningData.type === FlyoutDataTypes.WidgetSelectorFilter) {
    <app-flyout-widget-selector-filter [flyoutOpeningData]="flyoutOpeningData"></app-flyout-widget-selector-filter>
  }

  @if (flyoutOpeningData && flyoutOpeningData.type === FlyoutDataTypes.HoldoutSettings) {
    <app-flyout-holdout-settings [flyoutOpeningData]="flyoutOpeningData"></app-flyout-holdout-settings>
  }

  @if (flyoutOpeningData && flyoutOpeningData.type === FlyoutDataTypes.KpiSettings) {
    <app-flyout-kpi-settings [flyoutOpeningData]="flyoutOpeningData"></app-flyout-kpi-settings>
  }

  @if (flyoutOpeningData && flyoutOpeningData.type === FlyoutDataTypes.Recommendation) {
    <app-flyout-recommendation [flyoutOpeningData]="flyoutOpeningData"></app-flyout-recommendation>
  }

  @if (flyoutOpeningData && flyoutOpeningData.type === FlyoutDataTypes.SiteCheckRecommendations) {
    <app-flyout-site-check [flyoutOpeningData]="flyoutOpeningData"></app-flyout-site-check>
  }

  <!-- Add flyout component for session condition group here -->
</div>
